<template>
    <div v-if="loading">
        <v-container
            fluid
            pa-4
            class="loading-container"
        >
            <v-layout column align-center>
                <v-progress-circular
                    indeterminate
                    color="primary"
                    size="50"
                />
                <span
                    v-if="!hideLoadingText"
                    class="headline mt-3 font-weight-light"
                >
                    Loading
                </span>
            </v-layout>
        </v-container>
    </div>
    <div v-else-if="!loading && error">
        <slot name="error">
            <v-container fluid pa-4>
                <v-layout column align-center>
                    <v-icon color="primary" size="50">
                        warning
                    </v-icon>
                    <span class="headline mt-3 font-weight-light">
                        {{ error }}
                    </span>
                </v-layout>
            </v-container>
        </slot>
    </div>
    <div v-else>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: null
        },
        hideLoadingText: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="scss">
.loading-container {
    min-height: 400px;
}
</style>
